import Axios from "axios";
import CryptoJS from "crypto-js";
import OpenAI from "openai";
import { getUploads } from './Firebase'



const secretKey = "your_secret_key"; // Use a strong key and store it securely

const baseUrl = 'https://api.heygen.com'


const photosIds = [
    "077418182be1477c9d259156cc736beb",
    "0a315279757841e9ad2af34a5f7232ec",
    "0c2e571859a442e0aed5f007a3fe0936",
    "0d029cf75d5f412680a601b189a50c57",
    "29136698e7314eebbf58854c92a375cc",
    "29bce70dd75e48deb74b0206ac3a4c99",
    "2c7335c0fc574c57ad1b55b02f9c5921",
    "356dc07fbb3a49819fc1aaae121867ad",
    "3d31b6f2458547d59bcfb5ae3b6b2e0c",
    "3d36b3b7e5184d3497b0caf20df3aba5",
    "574465599f0f46c1b1ca9fc19069f66b",
    "58910d3f364746c08e2ecb04da83d489",
    "5d7ddcbb44304181abe94101546a4c9a",
    "5f72be5252e64546a0dcea48f551eae7",
    "65c672c4b21343a8a9c62cc1aad858a7",
    "7fda8ef34f2b4a4c866f699710e1e4dd",
    "98600bffaf0049b5a1cea2f881310c0f",
    "DfuPaYe0eEX19v4jNq1L",
    "b7ddbad68356492fa10fcf2a1182f0b4",
    "ed16dfc442f741439d2cb554a92c9f53",
    "ee40f646802241e1902a93b5cf05575c"
];

const avatar_ids = [
    "727416427",
    "Amy_standing_sofa_front",
    "Blanka_standing_outfoorbusiness_front",
    "FX9nXl8B1S2VyxlrSdI6",
    "Gala_standing_businesssofa_front_close",
    "Georgia_sitting_office_front",
    "Leos_sitting_sofa_front",
    "Leszek_standing_outdoorcasual_front",
    "Raul_sitting_sofa_front",
    "Timothy_sitting_office_front"
];



function encryptData(data) {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    return encodeURIComponent(encrypted); // Ensure it's safe for URLs
}

export function decryptData(encryptedData) {
    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedData), secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

export function handleRedirect(photo, type) {
    const encryptedPhoto = encryptData(photo);
    window.location.href = `/Portal/createvideo?type=${type}&item=${encryptedPhoto}`;
}





export async function getVideoStatus(id) {
    try {
        const response = await Axios.get(`${baseUrl}/v1/video_status.get?video_id=${id}`, {
            headers: {
                "x-api-key": process.env.REACT_APP_X_KEY
            }
        });
        return response.data.data;
    } catch (error) {
        console.error("Error fetching voices:", error);
        throw error;
    }
}


export async function UploadTalkingPhoto(image) {
    try {
        const response = await Axios.post('https://upload.heygen.com/v1/talking_photo', image, {
            headers: {
                'Content-Type': 'image/jpeg',
                "x-api-key": process.env.REACT_APP_X_KEY
            }
        });

        console.log("upload Response Data:", response.data);  // Log the response
        return response.data;  // Ensure the image ID or other data is returned
    } catch (error) {
        console.log('Error uploading photo:', error);
        return error.response.data;  // Return null in case of an error
    }
}






// Open AI Chat

export const client = new OpenAI({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY, // API key from your .env file
    dangerouslyAllowBrowser: true, // If using in a browser (not recommended)
});


export const generateImage = async (prompt) => {
    try {
        const body = {
            model: "dall-e-3",
            prompt: prompt,
            n: 1,
            size: "1024x1024",
        };

        const response = await Axios.post(
            "https://api.openai.com/v1/images/generations",
            body, // Send the body as the second parameter in axios.post
            {
                headers: {
                    Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
                    "Content-Type": "application/json", // Include this header for JSON payloads
                },
            }
        );

        console.log("Generated Image URL:", response.data.data[0].url);
        return response.data.data[0].url
        // Use the URL (response.data.data[0].url) to display or download the image
    } catch (error) {
        console.error("Error generating image:", error);
    }
};




